export default __webpack_public_path__ + "static/media/img2.3ee366c4.jpg";